export default {
    methods: {
        embeddedYoutubeLink: function (videoId) {
            return 'https://www.youtube.com/embed/' + videoId + '?playlist=' + videoId + '&playsinline=1&loop=0';
        }
    }
}